<template>
  <div class="ww dbt" style="background-color:white; border-radius: 8px;">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="150px"
      style="padding:40px;min-width:41vw;"
    >
      <el-form-item label="求购类别：" prop="category_id">
        <el-cascader
          :props="categorys"
          v-model="category"
          @change="onChange($event, 'categorys')"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="地区选择：" prop="province_id">
        <el-cascader
          :props="regions"
          v-model="region"
          @change="onChange($event, 'regions')"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="姓名：" prop="contact_name">
        <el-input placeholder="请输入姓名" v-model="form.contact_name"></el-input>
      </el-form-item>
      <el-form-item label="电话：" prop="contact_phone">
        <el-input placeholder="请输入联系电话" :value="form.contact_phone" @input="onInputPhone"></el-input>
      </el-form-item>
      <el-form-item label="标题：" prop="title">
        <el-input placeholder="请输入标题" v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item label="价格：" prop="price">
        <el-input  placeholder="请输入价格" :value="form.price" @input="onInput"></el-input>
      </el-form-item>
      <el-form-item label="描述：" prop="describe">
        <el-input  placeholder="请输入需求描述" type="textarea"  :autosize="{ minRows: 2, maxRows: 6}" v-model="form.describe"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="_makeover_api_buying_create" type="primary"
          >提交</el-button
        >
      </el-form-item>
    </el-form>
    <div class="dxy" style="width:100%;color:#909399;">请填写公司转让信息</div>
  </div>
</template>
<script>
import * as Api from "../api/index";
export default {
  name: "Layout",
  data() {
      var checkPhone = (rule, value, callback) => {
        console.log(value)
        if (!value) {
          callback(new Error('手机号码不能为空'));
        }
        console.log((/^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/.test(value)))
        if(!(/^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/.test(value))){ 
          callback(new Error('手机号码有误，请重填'));
        } else {
          callback();
        }
      };
    return {
      rules: {
        category_id: [
          { required: true, message: "请选择求购类别", trigger: "blur" },
        ],
        province_id: [
          { required: true, message: "请选择地区", trigger: "blur" },
        ],
        contact_name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        contact_phone: [
          { required: true, validator: checkPhone, trigger: "blur" },
        ],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        price: [{ required: true, message: "请输入加个", trigger: "blur" }],
        describe: [
          { required: true, message: "请输入需求描述", trigger: "blur" },
        ],
      },

      categorys: {
        lazy: true,
        expandTrigger: "hover",
        async lazyLoad(node, resolve) {
          const { level, data } = node;
          switch (level) {
            case 0:
              resolve(
                (await Api.makeover_api_common({ parent_id: "0" }))?.list?.map(
                  (item) => ({
                    value: item.category_id,
                    label: item.category_name,
                    leaf: level >= 1,
                  })
                )
              );
              break;
            case 1:
              resolve(
                (
                  await Api.makeover_api_common({ parent_id: data.value })
                )?.list?.map((item) => ({
                  value: item.category_id,
                  label: item.category_name,
                  leaf: level >= 1,
                }))
              );
              break;
            default:
              resolve();
              break;
          }
        },
      },
      category: [],
      regions: {
        lazy: true,
        // checkStrictly: true,
        expandTrigger: "hover",
        async lazyLoad(node, resolve) {
          const { level, data } = node;
          switch (level) {
            case 0:
              resolve(
                (await Api.get_province("1"))?.map((item) => ({
                  value: item.id,
                  label: item.name,
                  // leaf: level >= 1,
                }))
              );
              break;
            case 1:
              resolve(
                (await Api.get_province(data.value))
                  ?.map((item) => ({
                    value: item.id,
                    label: item.name,
                    // leaf: level >= 2,
                  }))
                  .filter((item) => {
                    
                    if (item.label == "所有") {
                      return false;
                    } else {
                      return true;
                    }
                  })
              );
              break;
            case 2:
              var arr = await Api.get_province(data.value);
              if (arr instanceof Array) {
                resolve(
                  arr
                    ?.map((item) => ({
                      value: item.id,
                      label: item.name,
                      leaf: level >= 1,
                    }))
                    .filter((item) => {
                 
                      if (item.label == "所有") {
                        return false;
                      } else {
                        return true;
                      }
                    })
                );
              } else {
                resolve();
              }

              break;
            default:
              resolve();
          }
        },
      },
      region: [],
      form: {
        category_id: "",
        province_id: "",
        city_id: "",
        region_id: "",
        contact_name: "", // 姓名
        contact_phone: "", // 电话
        title: "", // 标题
        price: "", // 价格
        describe: "", // 描述
        establishment_date: new Date().format("YYYY-mm-dd"), //创建时间
      },
    };
  },
  methods: {
    onInputPhone(e) {
      var reg = /^\d{0,11}$/
      this.form.contact_phone = reg.test(e) ? e : this.form.contact_phone
    },
    onInput(e){
      var reg = /^\d*\.{0,1}\d{0,2}$/
      this.form.price = reg.test(e) ? e : this.form.price
    },
    onChange(e, type) {
      switch (type) {
        case "categorys":
          this.form.category_id = e[e.length - 1];
          break;
        case "regions":
          this.form.province_id = this.region[0] ? this.region[0] : "";
          this.form.city_id = this.region[1] ? this.region[1] : "";
          this.form.region_id = this.region[2] ? this.region[2] : "";
          break;
      }
    },
    async _makeover_api_buying_create() {
      this.$refs["form"].validate((valid) => {
        console.log(valid);
        if (valid) {
          this.__submit();
        }
      });
    },
    async __submit() {
      try {
        const res = await Api.makeover_api_buying_create({
          ...this.form,
          // category_id: this.category[this.category.length - 1], // 类别id
          // province_id: this.region[0] ? this.region[0] : "", // 省份
          // city_id: this.region[1] ? this.region[1] : "", // 城市
          // region_id: this.region[2] ? this.region[2] : "", // 区域
          // contact_name: "", // 姓名
          // contact_phone: "", // 电话
          // title: "", // 标题
          // price: "", // 价格
          // describe: "", // 描述
          // establishment_date: "", //创建时间
        });
        console.log("ss", res);
        if (res.status == 200) {
          this.open();
        }
      } catch (err) {
        console.log(err);
      }
    },
    open() {
      this.$confirm("发布成功!", "提示", {
        confirmButtonText: "继续发布",
        cancelButtonText: "返回首页",
        callback: (e) => {
          console.log(e);
          if (e == "cancel") {
            this.$router.push("/home");
          }
        },
      });
    },
  },
};
</script>
